import { usePage } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'

export function useOrdersRequiringAction() {
  const { props } = usePage()

  const count = computed(() => props.value.ordersRequiringActionCount)

  return {
    count
  }
}
